import { useState, useEffect } from "react";
import { Layout } from "../components/Layout";
import { Seo } from "../components/Seo";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { Reveal, MaskedLines } from "../components/motion";
import { AffiliateButton } from "../components/Affiliate";
import { CtaBanner } from "../components/CtaBanner";
import { Markdown } from "../components/Markdown";
import { api } from "../lib/api";

const News = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/news").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
  <Layout>
    <Seo
      title="VPN News: Latest Industry Updates | VPNReviews.ai"
      description="The latest VPN industry news — server expansions, streaming detection changes, privacy rulings, and product updates, published as they happen."
    />
    <section className="grain relative overflow-hidden bg-[#0F172A]">
      <div className="hero-grid absolute inset-0" />
      <div className="relative mx-auto max-w-7xl px-6 py-20 lg:px-8">
        <p className="mb-4 text-xs font-bold uppercase tracking-[0.25em] text-[#7EAAFF]">VPN News</p>
        <h1 className="font-display text-4xl font-black tracking-tighter text-white sm:text-5xl lg:text-6xl">
          <MaskedLines lines={["The VPN Industry,", "As It Happens"]} />
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-300">
          Short, topical updates on the VPN market — expansions, blocks, rulings, and releases.
        </p>
      </div>
    </section>
    <Breadcrumbs crumbs={[{ label: "News" }]} />
    <section className="mx-auto max-w-4xl px-6 py-16 lg:px-8" data-testid="news-list">
      {items === null ? (
        <p className="py-20 text-center text-sm text-slate-500" data-testid="news-loading">Loading news…</p>
      ) : items.length === 0 ? (
        <p className="py-20 text-center text-sm text-slate-500" data-testid="news-empty-state">No news yet — check back soon.</p>
      ) : (
        <div className="space-y-10">
          {items.map((n, i) => (
            <Reveal key={n.slug} delay={i * 0.04}>
              <article className="border-b border-slate-200 pb-10" data-testid={`news-item-${n.slug}`}>
                <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#4687FF]">
                  {n.tag} · {n.date}
                </p>
                <h2 className="mt-3 font-display text-2xl font-extrabold tracking-tight text-[#0F172A]">{n.title}</h2>
                <div className="mt-3 text-sm leading-relaxed text-slate-600">
                  <Markdown content={n.body} />
                </div>
                {n.cta_label && n.cta_url && (
                  <div className="mt-2">
                    <AffiliateButton href={n.cta_url} testId={`news-cta-${n.slug}`} variant="ghost">
                      {n.cta_label}
                    </AffiliateButton>
                  </div>
                )}
              </article>
            </Reveal>
          ))}
        </div>
      )}
    </section>
    <CtaBanner />
  </Layout>
  );
};

export default News;
